// src/pages/AdminBlogManagement.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Plus, Edit, Trash2, CheckCircle, AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = `${API_URL}/posts`;

// --- YENİ JENERİK MODAL COMPONENT'İ ---
// Bu component artık form, onay ve başarı mesajlarını gösterebilecek.
const ActionModal = ({ modalState, onClose, onConfirm, onSave }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        // Modal açıldığında, eğer form gösterilecekse, ilgili post'un verilerini state'e al.
        if (modalState.type === 'form') {
            setFormData(modalState.post || { title: '', image_url: '', author: '', read_time: '', content: '' });
        }
    }, [modalState]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    // Modal kapalıysa hiçbir şey render etme
    if (!modalState.type) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
            <div className="bg-gray-800 rounded-lg p-8 w-full max-w-2xl text-white shadow-2xl">
                {/* FORM MODALI */}
                {modalState.type === 'form' && (
                    <>
                        <h2 className="text-2xl font-bold mb-6">{modalState.post ? 'Yazıyı Düzenle' : 'Yeni Yazı Ekle'}</h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <input type="text" name="title" value={formData.title || ''} onChange={handleChange} placeholder="Başlık" className="w-full bg-gray-700 p-2 rounded focus:ring-2 focus:ring-indigo-500 outline-none" required />
                            <input type="text" name="image_url" value={formData.image_url || ''} onChange={handleChange} placeholder="Görsel URL (/images/ornek.jpg)" className="w-full bg-gray-700 p-2 rounded focus:ring-2 focus:ring-indigo-500 outline-none" required />
                            <input type="text" name="author" value={formData.author || ''} onChange={handleChange} placeholder="Yazar" className="w-full bg-gray-700 p-2 rounded focus:ring-2 focus:ring-indigo-500 outline-none" required />
                            <input type="text" name="read_time" value={formData.read_time || ''} onChange={handleChange} placeholder="Okuma Süresi (örn: 5 Dakika)" className="w-full bg-gray-700 p-2 rounded focus:ring-2 focus:ring-indigo-500 outline-none" />
                            <textarea name="content" value={formData.content || ''} onChange={handleChange} placeholder="İçerik (HTML destekler)" rows="10" className="w-full bg-gray-700 p-2 rounded focus:ring-2 focus:ring-indigo-500 outline-none" required></textarea>
                            <div className="flex justify-end space-x-4 pt-4">
                                <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500 transition-colors">İptal</button>
                                <button type="submit" className="px-4 py-2 bg-indigo-600 rounded hover:bg-indigo-500 transition-colors">Kaydet</button>
                            </div>
                        </form>
                    </>
                )}

                {/* SİLME ONAY MODALI */}
                {modalState.type === 'confirmDelete' && (
                    <div className="text-center">
                        <AlertTriangle className="mx-auto h-16 w-16 text-yellow-500 mb-4" />
                        <h2 className="text-2xl font-bold mb-4">Emin misiniz?</h2>
                        <p className="text-gray-300 mb-6">Bu yazıyı kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</p>
                        <div className="flex justify-center space-x-4">
                            <button onClick={onClose} className="px-6 py-2 bg-gray-600 rounded hover:bg-gray-500 transition-colors">Vazgeç</button>
                            <button onClick={onConfirm} className="px-6 py-2 bg-red-600 rounded hover:bg-red-500 transition-colors">Evet, Sil</button>
                        </div>
                    </div>
                )}
                
                {/* BAŞARI MODALI */}
                {modalState.type === 'success' && (
                    <div className="text-center">
                        <CheckCircle className="mx-auto h-16 w-16 text-green-500 mb-4" />
                        <h2 className="text-2xl font-bold mb-4">Başarılı!</h2>
                        <p className="text-gray-300 mb-6">{modalState.message}</p>
                        <div className="flex justify-center">
                            <button onClick={onClose} className="px-6 py-2 bg-indigo-600 rounded hover:bg-indigo-500 transition-colors">Kapat</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


// --- ANA YÖNETİM SAYFASI ---
const AdminBlogManagement = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Modal state'ini artık boolean yerine bir obje ile yönetiyoruz.
    // type: 'form' | 'confirmDelete' | 'success'
    // data: işlem için gerekli ek bilgi (post objesi, post ID'si vb.)
    const [modalState, setModalState] = useState({ type: null, data: null });

    const fetchPosts = async () => {
        try {
            !loading && setLoading(true); // Sadece ilk yüklemede değil, her fetch'te loading olsun
            const response = await axios.get(ADMIN_API_URL);
            setPosts(response.data);
        } catch (err) {
            setError("Yazılar yüklenemedi.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    // KAYDETME (Ekleme/Güncelleme)
    const handleSavePost = async (formData) => {
        const isEditing = !!modalState.data?.id;
        const successMessage = isEditing ? "Yazı başarıyla güncellendi." : "Yazı başarıyla oluşturuldu.";
        try {
            if (isEditing) {
                await axios.put(`${ADMIN_API_URL}/${modalState.data.id}`, formData);
            } else {
                await axios.post(ADMIN_API_URL, formData);
            }
            fetchPosts();
            setModalState({ type: 'success', data: { message: successMessage } });
        } catch (err) {
            console.error("Kaydetme hatası:", err);
            alert("İşlem sırasında bir hata oluştu.");
        }
    };

    // SİLME ONAYINI GÖSTERME
    const handleDeleteRequest = (postId) => {
        setModalState({ type: 'confirmDelete', data: { postId } });
    };

    // ONAYLANDIKTAN SONRA SİLME
    const handleConfirmDelete = async () => {
        try {
            await axios.delete(`${ADMIN_API_URL}/${modalState.data.postId}`);
            fetchPosts();
            setModalState({ type: 'success', data: { message: "Yazı başarıyla silindi." } });
        } catch (err) {
            console.error("Silme hatası:", err);
            alert("Silme işlemi sırasında bir hata oluştu.");
        }
    };

    if (loading) return <div className="text-center text-white p-10">Yükleniyor...</div>;
    if (error) return <div className="text-center text-red-500 p-10">{error}</div>;

    return (
        <div className="min-h-screen bg-gray-900 text-white p-8">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">Blog Yönetimi</h1>
                    <button onClick={() => setModalState({ type: 'form', data: null })} className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded flex items-center space-x-2">
                        <Plus size={20} />
                        <span>Yeni Yazı Ekle</span>
                    </button>
                </div>
                
                <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden">
                    <table className="w-full text-left">
                        <thead className="bg-gray-700">
                            <tr>
                                <th className="p-4">Başlık</th>
                                <th className="p-4">Yazar</th>
                                <th className="p-4">Tarih</th>
                                <th className="p-4 text-right">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {posts.map(post => (
                                <tr key={post.id} className="border-b border-gray-700 hover:bg-gray-700/50">
                                    <td className="p-4">{post.title}</td>
                                    <td className="p-4">{post.author}</td>
                                    <td className="p-4">{new Date(post.date).toLocaleDateString('tr-TR')}</td>
                                    <td className="p-4 text-right">
                                        <button onClick={() => setModalState({ type: 'form', data: post })} className="text-yellow-400 hover:text-yellow-300 mr-4"><Edit size={20} /></button>
                                        <button onClick={() => handleDeleteRequest(post.id)} className="text-red-500 hover:text-red-400"><Trash2 size={20} /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <ActionModal 
                modalState={{type: modalState.type, post: modalState.data, message: modalState.data?.message}}
                onClose={() => setModalState({ type: null, data: null })}
                onSave={handleSavePost}
                onConfirm={handleConfirmDelete}
            />
        </div>
    );
};

export default AdminBlogManagement;